import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Route, withRouter } from 'react-router-dom';

import Navigation from './Navigation';
import LandingPage from './pages/LandingPage';
import HelpPage from './pages/HelpPage';
import PricingPage from './pages/PricingPage';
import FeaturesPage from './pages/FeaturesPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';

import PeoplePage from './pages/SearchablePeoplePage';
import PersonPage from './pages/PersonPage';

import { Query } from 'react-apollo';
import { ME_QUERY } from './graphql';

import './App.css';

class App extends Component {
  state = {
    user: null,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      user: nextProps.user,
    };
  }

  renderPublic = () => {
    return (
      <Container fluid={true}>
        <Row>
          <Col>
            <Route path="/" exact component={LandingPage} />
            <Route path="/help" component={HelpPage} />
            <Route path="/pricing" component={PricingPage} />
            <Route path="/features" component={FeaturesPage} />
            <Route path="/login" component={LoginPage} />
            <Route
              path="/signup"
              render={props => (
                <SignupPage
                  {...props}
                  authStateChanged={({ user }) => this.setState({ user })}
                />
              )}
            />
          </Col>
        </Row>
      </Container>
    );
  };

  renderPrivate = () => {
    const { location } = this.props;
    // return <pre>{JSON.stringify(this.props, null, 2)}</pre>;
    const showingPerson = location.pathname !== '/';

    return (
      <Container
        fluid={true}
        style={{
          height: 'calc(100vh - 57px)',
          overflow: 'hidden',
        }}
      >
        <Row style={{ height: '100%' }}>
          <div
            className={showingPerson ? 'col-sm-3 d-none d-md-block' : 'col'}
            style={{ overflowX: 'scroll', height: '100%' }}
          >
            <PeoplePage />
          </div>
          <Route
            path="/:name/:id"
            render={props => (
              <div
                className="col"
                style={{ overflowX: 'scroll', height: '100%' }}
              >
                <PersonPage {...props} />
              </div>
            )}
          />
        </Row>
      </Container>
    );
  };

  render() {
    const { loading, error } = this.props;
    const { user } = this.state;
    // return <pre>{JSON.stringify(this.props, null, 2)}</pre>;

    return (
      <div>
        <Navigation user={user} />
        {!user && this.renderPublic()}
        {user && this.renderPrivate()}
      </div>
    );
  }
}

export default withRouter(props => (
  <Query query={ME_QUERY}>
    {({ loading, error, data }) => (
      <App {...props} loading={loading} error={error} user={data && data.me} />
    )}
  </Query>
));



// WEBPACK FOOTER //
// ./src/App.js